var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({class:_vm.designClass,attrs:{"value":_vm.value,"outlined":"","clearable":_vm.clearable,"autocomplete":"new-password","dense":_vm.dense}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }